import { z } from 'zod';
import { defineEndpoint } from '../define';
import { ReleaseEnvironmentSchema } from './shapes';

/** Post a test message to the channel's saved Slack channel (Slack notifications card). */
export const sendSlackTestMessage = defineEndpoint({
  method: 'POST',
  path: '/v1/release-products/:productId/channels/:environment/slack-test',
  params: z.object({ productId: z.string().uuid(), environment: ReleaseEnvironmentSchema }),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({ data: z.object({ ok: z.literal(true) }) }),
});
